import React from 'react';
import { UserHelper } from "_helpers";
import Button from "@material-ui/core/Button";

class ChatHistory extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: ''
    };
  }

  handleChange(event) {
    this.setState({ inputValue: event.target.value });
    this.props.handleInputChange(event);
  }

  render() {
    const { chats, message } = this.props;

    return (
      <div style={root}>
        <div style={messagesDiv}>
          {chats?.map((chat_data, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: chat_data.message_by === "Visitor" ? "flex-start" : "flex-end",
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  background: chat_data.message_by === "Visitor" ? "#f1f3f4" : "#edccd2",
                  padding: "14px",
                  borderRadius: 8,
                  maxWidth: "70%",
                  wordWrap: "break-word",
                }}
              >
                {chat_data.message}
              </div>
            </div>
          ))}
        </div>
        {UserHelper.isConsultant() && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.props.handleSubmit(e);
            }}
            style={{ display: "flex", alignItems: "center" }}
          >
            <input
              name="message"
              style={input}
              type="text"
              value={message}
              onChange={(e) => this.handleChange(e)}
              placeholder="Type your message..."
            />
            <Button
              variant="contained"
              color="primary"
              type="submit"
              style={{ marginLeft: 10 }}
            >
              Send
            </Button>
          </form>
        )}
      </div>
    );
  }
}

export default ChatHistory;

const root = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  width: "100%",
};

const messagesDiv = {
  padding: 10,
  flex: 1,
  overflowY: "auto",
};

const input = {
  flex: 1,
  width: "86%",
  borderRadius: 5,
  margin: "0 10px 0 0",
  padding: 8,
};
